import Comparison from '@/types/comparison';
import { formatLocalizedString, FormattedHTMLMessage } from '@/utils/i18n';
import React, { FC, ReactElement } from 'react';

interface Props {
  comparison: Comparison;
  removedPlanPortfolios: Comparison['modifiedItems'];
}

const PlanRemovedPortfoliosBody: FC<Props> = ({ comparison, removedPlanPortfolios }): ReactElement => {
  if (!removedPlanPortfolios || removedPlanPortfolios.length === 0) {
    return <></>;
  }
  return (
    <>
      <p data-testid="comparison-modified-items">
        <FormattedHTMLMessage
          id="ComparisonMissingItemsModal.Body.UnlinkedPlanAccount.Top"
          values={{
            count: removedPlanPortfolios.length,
            comparison: comparison.name,
          }}
        />
      </p>
      <ul className="items-list">
        {removedPlanPortfolios?.map(portfolioItem => (
          <li key={portfolioItem.item._id}>{formatLocalizedString(portfolioItem.item.name)}</li>
        ))}
      </ul>
    </>
  );
};

export default PlanRemovedPortfoliosBody;
